import { render, staticRenderFns } from "./TrainingVideosList.vue?vue&type=template&id=056f05d6&scoped=true&"
import script from "./TrainingVideosList.vue?vue&type=script&lang=js&"
export * from "./TrainingVideosList.vue?vue&type=script&lang=js&"
import style0 from "./TrainingVideosList.vue?vue&type=style&index=0&id=056f05d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f05d6",
  null
  
)

export default component.exports